import React from 'react';
import { redirect, logAnalytics } from '../util';
import { useNavigate } from 'react-router-dom';
import { RedirectURLs } from '../constants/redirectURLS';
import appStore from '../assets/hq/appStore.svg';
import playStore from '../assets/hq/playStore.svg';
import web from '../assets/hq/webApp.svg';
import extension from '../assets/hq/chrome.svg';
import mascot from '../assets/hq/mascot.svg';

export default function AllProductsComponent() {
  const navigate = useNavigate();
  const cypherHQSolutions = [
    {
      img: appStore,
      title: 'App Store',
      color: '#2FB7EE',
      url: RedirectURLs.appStore,
    },
    {
      img: playStore,
      title: 'Play Store',
      color: '#62E4A8',
      url: RedirectURLs.playStore,
    },
    {
      img: web,
      title: 'DApp',
      color:
        'linear-gradient(0deg, #FFCA48 0%, #FFCA48 100%), linear-gradient(0deg, #F44336 0%, #F44336 100%)',
      url: RedirectURLs.dApp,
    },
    {
      img: extension,
      title: 'Chrome Extension',
      color:
        'linear-gradient(0deg, #F44336 0%, #F44336 100%), linear-gradient(0deg, #F44336 0%, #F44336 100%)',
      url: RedirectURLs.extension,
    },
    {
      img: mascot,
      title: 'Cypher Business',
      color:
        'linear-gradient(0deg, #FFCA48 0%, #FFCA48 100%), linear-gradient(0deg, #F44336 0%, #F44336 100%)',
      url: RedirectURLs.business,
    },
  ];
  return (
    <div className={'bg-[#2C2C2C] py-[76px] px-[52px] mx-auto w-full'}>
      <p
        className='font-semibold text-[24px] md:text-[32px] text-center'
        style={{
          background: 'linear-gradient(180deg, #FFF 0%, #6D6D6D 99%)',
          webkitBackgroundClip: 'text',
          WebkitTextFillColor: 'transparent',
        }}
      >
        {'Enjoy the freedom of spending your crypto anytime, '}
      </p>
      <p
        className='font-normal text-[24px] md:text-[34px] text-center'
        style={{
          background: 'linear-gradient(180deg, #FFF 0%, #6D6D6D 99%)',
          webkitBackgroundClip: 'text',
          WebkitTextFillColor: 'transparent',
        }}
      >
        {'anywhere in the world, with Cypher Products'}
      </p>
      <div className='hidden lg:block lg:flex lg:items-center lg:justify-center lg:space-x-3 lg:mt-[68px]'>
        {cypherHQSolutions.map((item, index) => (
          <div
            key={index}
            className='rounded-full py-[6px] px-[12px] border border-[#000] flex space-x-1 items-center justify-center max-w-max relative cursor-pointer'
            style={{
              background: 'linear-gradient(180deg, #5D5D5D 0%, #393939 100%)',
            }}
            onClick={() => {
              if (item.title === 'Cypher Business') {
                navigate('/business');
              } else {
                redirect(item.url);
              }
              logAnalytics({
                category: 'all products showcase',
                action: 'click' + item.title,
                label: item.title,
              });
            }}
          >
            <img alt='' src={item.img} className='w-[30px] h-[30px]' />
            <p className='font-semibold text-sm text-[#FFFFFF]'>{item.title}</p>
            <div
              className='absolute top-0 left-0 w-[54px] h-[38px] blur-[62px]'
              style={{
                background: item.color,
              }}
            />
          </div>
        ))}
      </div>
      <div className='block flex flex-col w-full mt-[68px] lg:hidden'>
        <div className='flex flex-row w-full justify-center mt-3'>
          {cypherHQSolutions.slice(0, 2).map((item, index) => {
            return (
              <div
                key={index}
                className={`rounded-full py-[8px]  border border-[#000] flex space-x-1 items-center justify-center w-[170px] relative cursor-pointer ${
                  index / 2 === 0 ? 'mr-3' : ''
                }`}
                style={{
                  background:
                    'linear-gradient(180deg, #5D5D5D 0%, #393939 100%)',
                }}
                onClick={() => {
                  redirect(item.url);
                }}
              >
                <img alt='' src={item.img} className='w-[24px] h-[24px]' />
                <p className='font-semibold text-sm text-[#FFFFFF]'>
                  {item.title}
                </p>
                <div
                  className='absolute top-0 left-0 w-[54px] h-[38px] blur-[62px]'
                  style={{
                    background: item.color,
                  }}
                />
              </div>
            );
          })}
        </div>
        <div className='flex flex-row w-full justify-center mt-3'>
          {cypherHQSolutions.slice(2, 4).map((item, index) => {
            return (
              <div
                key={index}
                className={`rounded-full py-[8px]  border border-[#000] flex space-x-1 items-center justify-center w-[170px] relative cursor-pointer ${
                  index / 2 === 0 ? 'mr-3' : ''
                }`}
                style={{
                  background:
                    'linear-gradient(180deg, #5D5D5D 0%, #393939 100%)',
                }}
                onClick={() => {
                  redirect(item.url);
                }}
              >
                <img alt='' src={item.img} className='w-[24px] h-[24px]' />
                <p className='font-semibold text-sm text-[#FFFFFF]'>
                  {item.title}
                </p>
                <div
                  className='absolute top-0 left-0 w-[54px] h-[38px] blur-[62px]'
                  style={{
                    background: item.color,
                  }}
                />
              </div>
            );
          })}
        </div>
        <div className='flex flex-row w-full justify-center mt-3'>
          {cypherHQSolutions.slice(4, 5).map((item, index) => {
            return (
              <div
                key={index}
                className='rounded-full py-[8px] border border-[#000] flex space-x-1 items-center justify-center w-[350px] relative cursor-pointer'
                style={{
                  background:
                    'linear-gradient(180deg, #5D5D5D 0%, #393939 100%)',
                }}
                onClick={() => {
                  if (item.title === 'Cypher Business') {
                    navigate('/business');
                  } else {
                    redirect(item.url);
                  }
                }}
              >
                <img alt='' src={item.img} className='w-[24px] h-[24px]' />
                <p className='font-semibold text-sm text-[#FFFFFF]'>
                  {item.title}
                </p>
                <div
                  className='absolute top-0 left-0 w-[54px] h-[38px] blur-[62px]'
                  style={{
                    background: item.color,
                  }}
                />
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}
